<template lang="pug">
  .body.operator-transport-waste.body-flex
    .table-choose-panel.body-flex
      .toolbar-table
        .toolbar.toolbar_no-padding.toolbar_margin-bottom
          .toolbar__line
            .semibold Транспортирование отходов
            .parameters.display-flex
              e-year-selector(year="year")
      e-table-editable(
        ref="garbage"
        :attributes="garbageDetailAttr"
        :dataUrl="garbageDataUrl"
        :tableInOnlineMode="true"
        :enabledActions='[]'
        :showSummaryColumns='true'
        :summaryColumns="['waste_total','waste_total_cubic']"
      )

</template>

<script>
import { tko } from '@/api/api-endpoints'
import year from '@/utils/year'

export default {
  name: 'operator-transport-waste',
  data() {
    return {
      year: year.getCurrentYear(),
    }
  },
  computed: {
    garbageDetailAttr() {
      return {
        fkko_name: {
          label: 'Наименование',
        },
        fkko_code: {
          label: 'Код ФККО',
        },
        fkko_danger_class: {
          label: 'Класс опасности',
        },
        fkko_composition_note: {
          label: 'Компонентный состав',
        },
        waste_total: {
          label: 'Масса транспортируемых отходов, тонн',
        },
        waste_total_cubic: {
          label: 'Объем транспортируемых отходов, м³',
        },
      }
    },
    garbageDataUrl() {
      return tko.operatorWaste({
        query: { operator_id: this.$route.params.id, year: this.year },
      })
    },
  },
}
</script>

<style scoped lang="scss"></style>
